import React, { useState } from "react";
import { useProductsContext, useAuthContext } from "../../contexts";
import { useNavigate,useLocation } from "react-router";
import commonObj from '../../../utils/Common';
import { notify } from "../../../utils/utils";

const CategoryCard = ({
  category: { id, categoryName, categoryDescription, categoryImage },
  url: url
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { applyFilters } = useProductsContext();
  const { token,userInfo } = useAuthContext();
  const [showCategory, setShowCategory] = useState(true);
  /*const clickHandlerOLD = () => {
    if (!token) {
      navigate("/login", { state: { from: location.pathname } });
      notify("warn", commonObj.getLabel('Please_Login_to_continue'));
    } else {
      if (id==userInfo?.categoryId) {
        navigate("/products/"+id, { state: { from: "category", categoryName:categoryName } });
      } else {
        notify("warn", commonObj.getLabel('You_not_register_for_category'));
      }
    }
  };*/
  const clickHandler = () => {
    navigate("/products/"+id, { state: { from: "category", categoryName:categoryName } });
  };
  return (
    <section
      className=" flex flex-col items-center rounded-xl   cursor-pointer gap-3 relative overflow-hidden  categoryContainer"
      onClick={clickHandler}
    >
      <img
        src={url+categoryImage}
        alt={categoryName}
        className="rounded-xl h-full w-full object-cover transition-all delay-75 ease-out"
      />
      <div
        className="
             flex flex-col w-full h-full justify-center items-center
            transition-all delay-75 absolute left-0 right-0 bottom-0 top-0 bg-black/[.06] rounded-xl"
      >
        <h1 className="text-3xl xs:text-4xl sm:text-3xl lg:text-4xl font-extrabold capitalize text-[--theme-color] shadow-sm p-3 break-all">
          {categoryName}
        </h1>
      </div>
    </section>
  );
};

export default CategoryCard;
